(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount-code"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__zuitableCartDiscountInitialized) return;
  window.__zuitableCartDiscountInitialized = true;

  const storageKey = 'zuitable_applied_discount_codes_v1';

  const normalize = (value) =>
    String(value || '').trim().toLowerCase();

  const readStoredCodes = () => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : [];
    } catch (error) {
      return [];
    }
  };

  const writeStoredCodes = (codes) => {
    try {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify([...new Set(codes.filter(Boolean).map(String))])
      );
    } catch (error) {}
  };

  const discountTitles = (cart) => {
    const titles = [];

    (cart?.cart_level_discount_applications || []).forEach((application) => {
      if (application?.title) titles.push(String(application.title));
    });

    (cart?.items || []).forEach((item) => {
      (item?.discounts || []).forEach((discount) => {
        if (discount?.title) titles.push(String(discount.title));
      });

      (item?.line_level_discount_allocations || []).forEach((allocation) => {
        const title = allocation?.discount_application?.title;
        if (title) titles.push(String(title));
      });
    });

    return [...new Set(titles)];
  };

  const cartHasCode = (cart, code) => {
    const wanted = normalize(code);
    if (!wanted) return false;
    return discountTitles(cart).some((title) => normalize(title) === wanted);
  };

  const cartHasMantel100 = (cart) =>
    discountTitles(cart).some((title) => normalize(title) === 'mantel100');

  const setMessage = (root, message, state = '') => {
    const box = root.querySelector('[data-cart-discount-message]');
    if (!box) return;

    box.textContent = message || '';

    if (state) box.dataset.state = state;
    else box.removeAttribute('data-state');
  };

  const setLoading = (root, loading) => {
    const button = root.querySelector('[data-cart-discount-apply]');
    if (!button) return;

    button.disabled = loading;
    button.textContent = loading
      ? root.dataset.applyingText
      : root.dataset.applyText;
  };

  const fetchCart = async (root) => {
    const response = await fetch(root.dataset.cartJs, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error(root.dataset.errorText);
    return response.json();
  };

  const updateDiscounts = async (root, codes) => {
    const response = await fetch(root.dataset.updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        discount: codes.join(',')
      })
    });

    const payload = await response.json().catch(() => null);

    if (!response.ok || !payload) {
      throw new Error(
        payload?.description ||
        payload?.message ||
        root.dataset.errorText
      );
    }

    return payload;
  };

  const applyCode = async (root) => {
    const input = root.querySelector('[data-cart-discount-input]');
    const code = String(input?.value || '').trim();

    if (!code) {
      input?.focus();
      return;
    }

    setLoading(root, true);
    setMessage(root, '');

    let previousCodes = readStoredCodes();

    try {
      const cartBefore = await fetchCart(root);

      if (
        cartHasMantel100(cartBefore) &&
        !previousCodes.some((item) => normalize(item) === 'mantel100')
      ) {
        previousCodes.push('Mantel100');
      }

      const requestedCodes = [
        ...previousCodes.filter((item) => normalize(item) !== normalize(code)),
        code
      ];

      const cartAfter = await updateDiscounts(root, requestedCodes);

      if (!cartHasCode(cartAfter, code)) {
        if (previousCodes.length) {
          await updateDiscounts(root, previousCodes).catch(() => {});
        }

        setMessage(root, root.dataset.notAppliedText, 'error');
        return;
      }

      writeStoredCodes(requestedCodes);
      input.value = '';
      setMessage(root, root.dataset.successText, 'success');

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartAfter }
        })
      );

      if (root.dataset.context === 'cart') {
        window.setTimeout(() => window.location.reload(), 350);
      }
    } catch (error) {
      setMessage(root, error?.message || root.dataset.errorText, 'error');
    } finally {
      setLoading(root, false);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-discount-apply]');
    if (!button) return;

    const root = button.closest('[data-cart-discount]');
    if (root) applyCode(root);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;

    const input = event.target.closest('[data-cart-discount-input]');
    if (!input) return;

    const root = input.closest('[data-cart-discount]');
    if (!root) return;

    event.preventDefault();
    applyCode(root);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mantel100-promo"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__mantel100Initialized) return;
  window.__mantel100Initialized = true;

  const root = document.querySelector('[data-mantel100-root]');
  if (!root) return;

  const modal = root.querySelector('[data-mantel100-modal]');
  const track = root.querySelector('[data-mantel100-track]');
  const status = root.querySelector('[data-mantel100-status]');
  const banner = root.querySelector('[data-mantel100-banner]');
  const configNode = root.querySelector('[data-mantel100-config]');
  const closeButtons = root.querySelectorAll('[data-mantel100-close]');
  const previousButton = root.querySelector('[data-mantel100-prev]');
  const nextButton = root.querySelector('[data-mantel100-next]');

  if (!modal || !configNode) return;

  let config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    return;
  }

  const qualifyingProductIds = new Set(
    (config.qualifyingProductIds || []).map((id) => String(id))
  );

  const dismissalKey = 'mantel100_offer_v2';
  let currentCart = null;
  let modalOpen = false;
  let lastFocus = null;
  let syncing = false;

  const isGiftLine = (item) =>
    String(item?.properties?._mantel100_gift || '') === '1';

  const giftLine = (cart) =>
    (cart?.items || []).find(isGiftLine) || null;

  const cartHasCoat = (cart) =>
    Boolean(
      cart?.items?.some((item) =>
        qualifyingProductIds.has(String(item.product_id))
      )
    );

  const coatSignature = (cart) =>
    (cart?.items || [])
      .filter((item) => qualifyingProductIds.has(String(item.product_id)))
      .map((item) => String(item.product_id))
      .sort()
      .join(',');

  const cartToken = (cart) => String(cart?.token || '');

  const dismissalValue = (cart) =>
    cartToken(cart) + '|' + coatSignature(cart);

  const readDismissal = () => {
    try {
      return sessionStorage.getItem(dismissalKey) || '';
    } catch (error) {
      return '';
    }
  };

  const writeDismissal = (value) => {
    try {
      sessionStorage.setItem(dismissalKey, value);
    } catch (error) {}
  };

  const clearDismissal = () => {
    try {
      sessionStorage.removeItem(dismissalKey);
    } catch (error) {}
  };

  const setStatus = (message = '', success = false) => {
    if (!status) return;
    status.textContent = message;
    if (success) status.dataset.success = 'true';
    else status.removeAttribute('data-success');
  };

  const fetchCart = async () => {
    const response = await fetch(root.dataset.cartJs, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error(root.dataset.errorText);
    return response.json();
  };

  const removeLine = async (line) => {
    if (!line?.key) return;

    await fetch(root.dataset.cartChangeJs, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: line.key,
        quantity: 0
      })
    });
  };

  const showModal = () => {
    if (modalOpen) return;
    modalOpen = true;
    lastFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mantel100-lock');
    window.setTimeout(() => modal.querySelector('.mantel100-modal__close')?.focus(), 0);
  };

  const hideModal = (remember = true) => {
    if (!modalOpen) return;

    if (remember && currentCart) {
      writeDismissal(dismissalValue(currentCart));
    }

    modalOpen = false;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mantel100-lock');

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  };

  const syncCart = async (cart, allowOpen = true) => {
    currentCart = cart;

    const hasCoat = cartHasCoat(cart);
    const promoGift = giftLine(cart);

    if (!hasCoat) {
      clearDismissal();

      if (promoGift) {
        await removeLine(promoGift).catch(() => {});
        currentCart = await fetchCart().catch(() => cart);
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      }

      hideModal(false);
      return;
    }

    if (promoGift) {
      clearDismissal();
      hideModal(false);
      return;
    }

    if (
      allowOpen &&
      readDismissal() !== dismissalValue(cart)
    ) {
      showModal();
    }
  };

  const refresh = async (allowOpen = true) => {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await fetchCart();
      await syncCart(cart, allowOpen);
    } catch (error) {
    } finally {
      syncing = false;
    }
  };

  const scheduleRefresh = () => {
    [250, 650, 1200].forEach((delay) => {
      window.setTimeout(() => refresh(true), delay);
    });
  };

  if (banner) {
    const target =
      document.querySelector('.product__info') ||
      document.querySelector('.product-form') ||
      document.querySelector('product-form') ||
      document.querySelector('.product-meta');

    if (target?.parentNode) {
      target.parentNode.insertBefore(banner, target.nextSibling);
    }
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => hideModal(true));
  });

  document.addEventListener('keydown', (event) => {
    if (!modalOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      hideModal(true);
      return;
    }

    if (event.key === 'Tab') {
      const focusable = [
        ...modal.querySelectorAll(
          'button:not([disabled]), select:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'
        )
      ];

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  previousButton?.addEventListener('click', () => {
    track?.scrollBy({
      left: -(track.clientWidth * 0.82),
      behavior: 'smooth'
    });
  });

  nextButton?.addEventListener('click', () => {
    track?.scrollBy({
      left: track.clientWidth * 0.82,
      behavior: 'smooth'
    });
  });

  root.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mantel100-add]');
    if (!button) return;

    const card = button.closest('[data-mantel100-card]');
    const select = card?.querySelector('[data-mantel100-variant]');
    const variantId = select?.value;

    if (!variantId) return;

    button.disabled = true;
    setStatus(root.dataset.addingText);

    let addedGiftLine = null;
    let giftWasAdded = false;

    try {
      const cartBefore = await fetchCart();

      if (!cartHasCoat(cartBefore)) {
        throw new Error(root.dataset.noCoatText);
      }

      if (giftLine(cartBefore)) {
        throw new Error(root.dataset.alreadySelectedText);
      }

      const addResponse = await fetch(root.dataset.cartAddJs, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: {
                _mantel100_gift: '1',
                _mantel100_offer: '2026_09'
              }
            }
          ]
        })
      });

      if (!addResponse.ok) {
        const error = await addResponse.json().catch(() => ({}));
        throw new Error(error.description || root.dataset.errorText);
      }

      giftWasAdded = true;

      const updateResponse = await fetch(root.dataset.cartUpdateJs, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          discount: root.dataset.discountCode
        })
      });

      if (!updateResponse.ok) {
        throw new Error(root.dataset.discountFailedText);
      }

      currentCart = await updateResponse.json();

      addedGiftLine =
        (currentCart.items || []).find(
          (item) =>
            isGiftLine(item) &&
            String(item.variant_id) === String(variantId)
        ) || giftLine(currentCart);

      if (
        !addedGiftLine ||
        Number(addedGiftLine.final_line_price) !== 0
      ) {
        if (addedGiftLine) {
          await removeLine(addedGiftLine).catch(() => {});
          currentCart = await fetchCart().catch(() => currentCart);
        }

        throw new Error(root.dataset.discountFailedText);
      }

      clearDismissal();
      setStatus(root.dataset.successText, true);

      root.querySelectorAll('[data-mantel100-add]').forEach((giftButton) => {
        giftButton.disabled = true;
      });

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: currentCart }
        })
      );

      window.setTimeout(() => {
        window.location.assign(root.dataset.cartUrl);
      }, 500);
    } catch (error) {
      if (giftWasAdded) {
        try {
          const cartAfterFailure = await fetchCart();
          const failedGift =
            (cartAfterFailure.items || []).find(
              (item) =>
                isGiftLine(item) &&
                String(item.variant_id) === String(variantId)
            ) || null;

          if (failedGift) {
            await removeLine(failedGift);
          }

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        } catch (cleanupError) {
        }
      }

      setStatus(error.message || root.dataset.errorText);
      button.disabled = false;
    }
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute('action') || '';
      if (action.includes('/cart/add')) scheduleRefresh();
    },
    true
  );

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:update', 'product:added', 'variant:added'].forEach(
    (eventName) => {
      document.addEventListener(eventName, (event) => {
        const eventCart = event.detail?.cart;

        if (eventName === 'cart:updated' && eventCart?.token) {
          syncCart(eventCart, true).catch(() => {});
        } else {
          scheduleRefresh();
        }
      });
    }
  );

  window.addEventListener('pageshow', () => refresh(true));

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh(true);
  });

  refresh(true);
})();
  } catch(e) { console.error(e); }
})();

})();
